// extracted by mini-css-extract-plugin
export default {"generalInfoContent":"styles_generalInfoContent__RfY8U","image":"styles_image__ek+Ex"};